import React from 'react';
import { Alert, Button, Form, Input, Space, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';

// T-222: al posto del form di login quando Google viene rifiutato perche'
// l'email ha gia' un account. Testi uguali a quelli approvati per l'app.
//
// Rientro solo con email e password: il link via email riapre la pagina,
// spesso in una scheda nuova, dove la credenziale Google in sospeso non c'e'
// piu' (sessionStorage vale per la singola scheda).

interface Props {
  email: string;
  busy: boolean;
  error: string | null;
  onPassword: (password: string) => void;
  onCancel: () => void;
}

export function LinkAccountPanel({ email, busy, error, onPassword, onCancel }: Props): React.ReactElement {
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Typography.Title level={4} style={{ margin: 0 }}>
        Hai già un account
      </Typography.Title>
      <Typography.Paragraph style={{ margin: 0 }}>
        Con <strong>{email}</strong> sei già registrato. Accedi con il metodo che hai usato la prima volta:
        poi colleghiamo anche Google e potrai entrare in tutti e due i modi.
      </Typography.Paragraph>

      {error && <Alert type="error" showIcon message={error} />}

      <Form
        name="link-account"
        layout="vertical"
        onFinish={(values: { password: string }) => onPassword(values.password)}
      >
        <Form.Item
          name="password"
          label="PASSWORD DEL TUO ACCOUNT"
          rules={[{ required: true, min: 6, message: 'Inserisci la password del tuo account.' }]}
        >
          <Input.Password prefix={<LockOutlined />} autoComplete="current-password" disabled={busy} />
        </Form.Item>
        <Button type="primary" htmlType="submit" block size="large" loading={busy}>
          ACCEDI CON EMAIL E PASSWORD
        </Button>
      </Form>

      <Button block onClick={onCancel} disabled={busy}>
        ANNULLA
      </Button>
    </Space>
  );
}
